import { useLocation } from 'react-router-dom';
import '../pages/RoomPage.css';
import '../pages/ViewerPage.css';

/** Экран «Загружаем комнату…» — тот же при ожидании lazy-чанка и при bootstrap в RoomPage. */
export function RoomRouteLoadingShell({ progressPercent }: { progressPercent: number }) {
  return (
    <div
      className="room-page room-page-v2 room-page--blocked"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="viewer-blocked-card">
        <h1 className="viewer-blocked-title">Загружаем комнату…</h1>
        <p className="viewer-blocked-text">
          Подтягиваем подключения и синхронизируем состояние панели.
        </p>
        <span className="sr-only">Загрузка комнаты и подключений</span>
        <div className="viewer-loading-progress viewer-loading-progress--bare" aria-hidden="true">
          <div
            className="viewer-loading-progress-bar viewer-loading-progress-bar--determinate"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
}

/** Экран «Загружаем страницу…» — как при проверке подключения на ViewerPage. */
export function ViewerRouteLoadingShell() {
  return (
    <div
      className="viewer-page fullscreen viewer-page--blocked"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="viewer-blocked-card">
        <h1 className="viewer-blocked-title">Загружаем страницу…</h1>
        <p className="viewer-blocked-text">
          Подключаем данные комнаты и синхронизируем состояние.
        </p>
        <span className="sr-only">Загрузка экрана таймера</span>
        <div className="viewer-loading-progress" aria-hidden="true">
          <div className="viewer-loading-progress-bar" />
        </div>
      </div>
    </div>
  );
}

/** Fallback для React.Suspense: тот же UI, что и после монтирования страницы (чанк ещё грузится). */
export function LazyChunksSuspenseFallback() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/room/')) {
    return <RoomRouteLoadingShell progressPercent={0} />;
  }
  if (pathname.startsWith('/viewer/')) {
    return <ViewerRouteLoadingShell />;
  }
  return (
    <div
      className="min-h-screen w-full bg-[var(--bg-page)]"
      aria-busy="true"
      aria-live="polite"
    >
      <span className="sr-only">Загрузка интерфейса</span>
    </div>
  );
}
